import { formatUsPhone, SignatureTemplateParams } from './TemplateParams';

export function TS1SignatureTemplate({
  params,
  showPhoto = false,
}: {
  params: SignatureTemplateParams;
  showPhoto?: boolean;
}) {
  const { name, title, email, phone, disablePhoneNumber } = params;
  if (showPhoto === true) {
    return <>photo</>;
  }

  return (
    <>
      <link
        rel="preload"
        as="image"
        href="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/logo-saP5p7DV6Nc0TFI1AOPAo.png"
      />
      <link
        rel="preload"
        as="image"
        href="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/linkedin-rrM1btcBtzQEqtPOIshte.png"
      />
      <link
        rel="preload"
        as="image"
        href="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/youtube-Z6pKPDc_yz9EIzLQ3YHOb.png"
      />
      <link
        rel="preload"
        as="image"
        href="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/instagram-j47Mlqlc4X_80_2c5t3RN.png"
      />
      <link
        rel="preload"
        as="image"
        href="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/facebook-fkIqogPvR8g3mup4t-yix.png"
      />
      <link
        rel="preload"
        as="image"
        href="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/tiktok-eVjy7r72oafYOL2b9JeV3.png"
      />
      <table
        //@ts-expect-error because
        align="center"
        width="100%"
        border="0"
        cellPadding="0"
        cellSpacing="0"
        role="presentation"
        style={{
          fontFamily: 'Arial, sans-serif',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          flex: '1 1 auto',
          borderTop: '1px solid #ccc',
          paddingTop: '20px',
          marginTop: '20px',
        }}
      >
        <tbody>
          <tr style={{ width: '100%' }}>
            <td>
              <p
                style={{
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: '#101828',
                  fontWeight: 'bold',
                  margin: '0',
                  marginTop: '0',
                  marginBottom: '0',
                  marginLeft: '0',
                  marginRight: '0',
                }}
              >
                {name}
              </p>
              <p
                style={{
                  fontSize: '14px',
                  lineHeight: '24px',
                  color: '#101828',
                  margin: '2px 0',
                  marginTop: '2px',
                  marginRight: '0',
                  marginBottom: '2px',
                  marginLeft: '0',
                }}
              >
                {title}
              </p>
              <table
                //@ts-expect-error because
                align="center"
                width="100%"
                border="0"
                cellPadding="0"
                cellSpacing="0"
                role="presentation"
                style={{
                  maxWidth: '37.5em',
                  color: '#4A5565',
                  fontSize: '14px',
                  margin: '10px 0 20px 0',
                }}
              >
                <tbody>
                  <tr style={{ width: '100%' }}>
                    <td>
                      <a
                        href={`mailto:${email}`}
                        style={{
                          color: '#4A5565',
                          textDecorationLine: 'none',
                          textDecoration: 'underline',
                        }}
                        target="_blank"
                      >
                        {email}
                      </a>
                      {!disablePhoneNumber ? ` | ${formatUsPhone(phone)}` : ''}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                //@ts-expect-error because
                align="center"
                width="100%"
                border="0"
                cellPadding="0"
                cellSpacing="0"
                role="presentation"
                style={{ maxWidth: '37.5em', marginTop: '16px' }}
              >
                <tbody>
                  <tr style={{ width: '100%' }}>
                    <td>
                      <a
                        href="https://www.teamsnap.com/"
                        style={{ color: '#067df7', textDecorationLine: 'none' }}
                        target="_blank"
                      >
                        <img
                          alt="TeamSnap ONE Logo"
                          src="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/logo-saP5p7DV6Nc0TFI1AOPAo.png"
                          style={{
                            display: 'block',
                            outline: 'none',
                            border: 'none',
                            textDecoration: 'none',
                            width: '150px',
                            height: 'auto',
                          }}
                        />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                //@ts-expect-error because
                align="center"
                width="100%"
                border="0"
                cellPadding="0"
                cellSpacing="0"
                role="presentation"
                style={{
                  maxWidth: '37.5em',
                  marginTop: '16px',
                  textAlign: 'left',
                }}
              >
                <tbody>
                  <tr style={{ width: '100%' }}>
                    <td>
                      <a
                        href="https://www.linkedin.com/company/teamsnap"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        style={{
                          color: '#067df7',
                          textDecorationLine: 'none',
                          marginRight: '8px',
                          display: 'inline-block',
                        }}
                        target="_blank"
                      >
                        <img
                          alt="LinkedIn Icon"
                          src="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/linkedin-rrM1btcBtzQEqtPOIshte.png"
                          style={{
                            display: 'block',
                            outline: 'none',
                            border: 'none',
                            textDecoration: 'none',
                            height: '18px',
                            verticalAlign: 'middle',
                          }}
                        />
                      </a>
                      <a
                        href="https://www.youtube.com/@Teamsnapapp"
                        rel="noopener noreferrer"
                        aria-label="YouTube"
                        style={{
                          color: '#067df7',
                          textDecorationLine: 'none',
                          marginRight: '8px',
                          display: 'inline-block',
                        }}
                        target="_blank"
                      >
                        <img
                          alt="YouTube Icon"
                          src="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/youtube-Z6pKPDc_yz9EIzLQ3YHOb.png"
                          style={{
                            display: 'block',
                            outline: 'none',
                            border: 'none',
                            textDecoration: 'none',
                            height: '18px',
                            verticalAlign: 'middle',
                          }}
                        />
                      </a>
                      <a
                        href="https://www.instagram.com/teamsnapapp/"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                        style={{
                          color: '#067df7',
                          textDecorationLine: 'none',
                          marginRight: '8px',
                          display: 'inline-block',
                        }}
                        target="_blank"
                      >
                        <img
                          alt="Instagram Icon"
                          src="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/instagram-j47Mlqlc4X_80_2c5t3RN.png"
                          style={{
                            display: 'block',
                            outline: 'none',
                            border: 'none',
                            textDecoration: 'none',
                            height: '18px',
                            verticalAlign: 'middle',
                          }}
                        />
                      </a>
                      <a
                        href="https://www.facebook.com/TeamSnap"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                        style={{
                          color: '#067df7',
                          textDecorationLine: 'none',
                          marginRight: '8px',
                          display: 'inline-block',
                        }}
                        target="_blank"
                      >
                        <img
                          alt="Facebook Icon"
                          src="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/facebook-fkIqogPvR8g3mup4t-yix.png"
                          style={{
                            display: 'block',
                            outline: 'none',
                            border: 'none',
                            textDecoration: 'none',
                            height: '18px',
                            verticalAlign: 'middle',
                          }}
                        />
                      </a>
                      <a
                        href="https://www.tiktok.com/@teamsnapapp"
                        rel="noopener noreferrer"
                        aria-label="TikTok"
                        style={{
                          color: '#067df7',
                          textDecorationLine: 'none',
                          marginRight: '8px',
                          display: 'inline-block',
                        }}
                        target="_blank"
                      >
                        <img
                          alt="TikTok Icon"
                          src="https://ts-public-assets.teamsnap.com/email/signatures/ts1/v1/tiktok-eVjy7r72oafYOL2b9JeV3.png"
                          style={{
                            display: 'block',
                            outline: 'none',
                            border: 'none',
                            textDecoration: 'none',
                            height: '18px',
                            verticalAlign: 'middle',
                          }}
                        />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}
